import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../../context/ConstantAPISContext";
import { showToast } from "../../../../helpers/ToastifyHelper";
import { Form, Formik } from "formik";
import { FormControl, InputLabel, MenuItem, Select, TextField, CircularProgress } from "@mui/material";
import SearchComponent from "../../../../components/OB/SearchComponent";
import TableComponent from "../../../../components/OB/TableComponent";
import CaddeSokakAPI from "../../../../apis/OB/Get/CaddeSokakAPI";
import CevreTemizlikBildirimAPI from "../../../../apis/OB/Get/CevreTemizlikBildirimAPI";
import CtvExportPdfAPI from "../../../../apis/OB/Rapor/CtvExportPdfAPI";
import { openFileInNewTab } from "../../../../helpers/openFileNewTab";
import { today } from "../../../../helpers/TodayDate";
import CtvBorcKontrolAPI from "../../../../apis/OB/Get/CtvBorcKontrolAPI";
import TableComponent2 from "../../../../components/OB/TableComponent2";
import SessionStorageService from "../../../../services/StorageService";

const CevreTemizlikBildirim = (props: any) => {

    const columnsArsa = [
        { header: "", field: "", className: "text-center", classNameDiv: "d-flex gap-2", beyan: 2 },
        { header: "Adres", field: "adres", className: "text-center" },
        { header: "Pafta/Ada/Parsel", field: "paftaAdaParsel", className: "text-center" },
        { header: "Mük. Başlama Tarihi", field: "mukBaslamaTarihi", className: "text-center" },
        { header: "Kul. Başlama Tarihi", field: "kulBaslamaTarihi", className: "text-center" },
        { header: "Beyan Kabul Tarihi", field: "beyanKabulTarihi", className: "text-center" },
        { header: "Faaliyet Adı", field: "faaliyetAdi", className: "text-center" },
        { header: "Faaliyet Adı", field: "grupDerece", className: "text-center" },
        { header: "Mükellefiyet Bitiş Tarihi", field: "mukellefiyetBitisTarihi", className: "text-center" },
        { header: "K. Sıra No", field: "kSiraNo", className: "text-center" },
    ];

    // Borç Kontrol ve Beyan Sureti İşlemi Pdf
    const exportCtvSuret = (sqId: string) => {
        CtvExportPdfAPI.geExportPdfListe(sqId)
            .then((res) => {
                if (res.data !== null) {
                    openFileInNewTab(
                        res.data.reportUrlByteFormat,
                        "-Ctv Sureti - " + today + ".pdf"
                    );
                } else {
                    showToast("Pdf indirilirken bir sorun oluştu", "error")
                }
            })
            .catch((err) => {
                showToast("Pdf indirilirken bir sorun oluştu", "error")
            });
    };

    const borcKontrol = (sqId: number, durum: number) => {
        CtvBorcKontrolAPI.getCtvBorcKontrol(sqId, durum)
            .then((res) => {
                res.data[0].sonuc == 1 ? showToast("Borç kaydınız bulunmamaktadır", "info") : exportCtvSuret(sqId.toString());
            })
            .catch((err) => {
                showToast("İşleminizi şu anda gerçekleştiremiyoruz", "error")
            });
    };

    let user = SessionStorageService.getUserInfo();

    const [data, setData] = useState<any[]>([]);

    const [searchControl, setSearchControl] = useState<boolean>(true);
    const { mahalleListe } = useContext(ConstantAPISContext);
    const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<any>();
    const [selectedCaddeSokakKodu, setSelectedCaddeSokakKodu] = useState<any>(undefined);
    const [caddeSokakDatas, setCaddeSokakDatas] = useState<any[]>([]);
    const [aktifPasif, setAktifPasif] = useState<number>(1);
    const [ada, setAda] = useState<any>(undefined);
    const [parsel, setParsel] = useState<any>(undefined);

    const [isLoading, setisLoading] = useState<boolean>(false);

    //CaddeSokakAPI
    useEffect(() => {
        if (
            selectedMahalleKodu !== undefined &&
            !Number.isNaN(selectedMahalleKodu)
        ) {
            setisLoading(true);
            CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
                .then((res) => {
                    setCaddeSokakDatas(res.data);
                    setTimeout(() => {
                        setisLoading(false);

                    }, 100)
                })
                .catch((err) => {
                });
        }
    }, [selectedMahalleKodu]);

    //CevreTemizlikAPI
    useEffect(() => {
        fetchData(false);
    }, [])

    const fetchData = async (isPass: boolean = true) => {
        const response = await CevreTemizlikBildirimAPI.getCevreTemizlikBildirimListe(
            user?.sicilKodu,
            aktifPasif,
            ada || null,
            parsel || null,
            selectedMahalleKodu || null,
            selectedCaddeSokakKodu || null,
        )
        setData(response.data);
        setSearchControl(true)
        if (response.data.length < 1)
            showToast("Kayıt Bulunamadı!", "warning");
    }

    const handleTemizle = () => {
        setSelectedCaddeSokakKodu(undefined)
        setSelectedMahalleKodu(undefined)
        setAktifPasif(1)
        setAda(undefined)
        setParsel(undefined)
    }

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <div className="px-1 pt-1">
            <Formik
                initialValues={initialValues}
                onSubmit={() => { }}>
                <Form id="kayit-form" className="d-flex w-100 mb-4">
                    <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                        <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id=""></InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    label=""
                                    value={aktifPasif || ""}
                                    onChange={(e) => {
                                        setAktifPasif(Number(e.target.value));
                                    }}
                                >
                                    <MenuItem selected value={1}>{"Aktif"}</MenuItem>
                                    <MenuItem value={2}>{"Pasif"}</MenuItem>
                                    <MenuItem value={3}>{"Hepsi"}</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id="">Mahalle</InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    error={selectedMahalleKodu == undefined && searchControl == false ? true : false}
                                    value={selectedMahalleKodu || ""}
                                    label="Mahalle"
                                    onChange={(e) => {
                                        setSelectedMahalleKodu(Number(e.target.value || undefined));
                                        setSelectedCaddeSokakKodu(undefined)
                                    }}
                                >
                                    {mahalleListe.map((item) => (
                                        <MenuItem
                                            key={item}
                                            value={item.mahalleKodu}                                            >
                                            {item.mahalleAdi}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id="">Cadde/Sokak</InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    value={selectedCaddeSokakKodu || ""}
                                    label="Cadde/Sokak"
                                    onChange={(e) => {
                                        setSelectedCaddeSokakKodu(Number(e.target.value || undefined));
                                    }}
                                >
                                    {caddeSokakDatas.map((item) => (
                                        <MenuItem
                                            key={item}
                                            value={item.caddeSokakKodu}                                            >
                                            {item.caddeSokakAdi}
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <TextField id="" label="Ada" variant="outlined" size="small"
                                    value={ada || ""}
                                    onChange={(event) => event.target.value === "" ? setAda("") : event.target.value.match(/^[0-9]+$/) ? setAda(event.target.value.substring(0, 10)) : null}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <TextField id="" label="Parsel" variant="outlined" size="small"
                                    value={parsel || ""}
                                    onChange={(event) => event.target.value === "" ? setParsel("") : event.target.value.match(/^[0-9]+$/) ? setParsel(event.target.value.substring(0, 10)) : null}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                        },
                                    }}
                                />
                            </FormControl>
                        </div>
                        <div className="d-flex  flex-row ms-auto ">
                            <SearchComponent
                                fetchData={fetchData}
                                onTemizle={handleTemizle}
                                setData={setData} />
                        </div>

                    </div>
                </Form>
            </Formik>
            {isLoading ?
                <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                    <CircularProgress />
                </div>
                :
                <TableComponent2 columns={columnsArsa} data={data} recordsPerPage={5} borcKontrol={borcKontrol}></TableComponent2>
            }
        </div >
    )
}

export default CevreTemizlikBildirim;